// Soft UI Dashboard React components
import { useAlert } from 'react-alert'
import { Grid, Snackbar, TextField,Button,Modal } from '@mui/material'
import ModeEditIcon from '@mui/icons-material/Edit'
import axios from 'axios'
import React, { useEffect, useReducer, useMemo, useState, Fragment, useRef } from 'react'
import Box from '@mui/material/Box'
import moment from 'moment';
import PatientRegistration from "./PatientRegistration";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

import { Controller, useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'

import { Typography } from '@mui/material'

// import Avatar from 'react-avatar'

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

const DisplayComments = (props) => {
  // const [hidePatientName, sethidepatientname] = useState(props.patientId > 0 ? true : false)
  //const comid = (commentId = null && commentId > 0 ? commentId : 0)
  const [errormessage, seterrormessage] = useState(false)
  const [rowsArchived, setRowsArchived] = useState(null)
  const [selectedRow, setselectedRow] = useState('')
  const [isShown, setIsShown] = useState(false)
  const [messagelist, setMessagelist] = useState('')
  const [commentOpen, setcommentOpen] = useState(false)

  const dat = [{ id: 1, firstname: 'Ummar', lastname: 'Gujjar' }]
  const [data, setData] = useState(dat)
  const [tabValue, settabValue] = React.useState(0)
  const [rows, setRows] = useState('')
  const PatientId= props.patientId

  const alert = useAlert()

  // const actionButton = cellValues => {

  //   router.push({
  //     pathname: `/patients/patient_registration`,
  //     query: { pid: cellValues.row.patientId

  //     }
  //   })
  // }

  const handleChange1 = (event, newValue) => {
    settabValue(newValue)
  }


  const [submitting, setSubmitting] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [patientopen, setpatientopen] = useState('')
  const token = localStorage.getItem('Token')
  const auth = `Bearer ${token}`
  const headers = {
    Authorization: auth
  }
  const handleChange = (event, newValue) => {
    settabValue(newValue)
  }

  const fields = [
    'id',
    'patientId',
    'parentId',
    'patientNoteId',
    'name',
    'shortName',
    'type',
    'phoneNo',
    'fax',
    'emailAddress',
    'city',
    'state',
    'zipCode',
    'deleted',
    'createdBy',
    'createdDate',
    'parentId',
    'updatedBy',
    'updatedDate',
    'clientCreatedDate',
    'clientModifiedDate',
    'defaultPOS',
    'practice_id',
    'defaultFacility',
    'npi',
    'fullName',
    'address',
    'date',
    'patientName',
    'comments',
    'dueDate',
    'assignedTo',
    'archive'
  ]
  const defValues = {
    id: 0,
    patientName: '',
    patientId: props.patientId,
    parentId: props.parentId,
    patientNoteId: 0,
    address: '',
    fullName: '',
    shortName: '',
    type: '',
    phoneNo: '',
    fax: '',
    emailAddress: '',
    city: '',
    state: '',
    zipCode: '',
    deleted: false,
    createdBy: '',
    practice_id: '',
    createdDate: '',
    updatedBy: '',
    updatedDate: '',
    clientCreatedDate: '',
    clientModifiedDate: '',
    defaultPOS: '',
    defaultFacility: '',
    npi: '',
    fullName: '',
    address: '',
    date: '',
    comments: '',
    dueDate: '',
    parentId: '',
    assignedTo: '',
    archive: ''
  }
  const validationSchema = Yup.object({
    patientName: Yup.string().required('Patient Name is required'),
    comments: Yup.string().required('Messages are required')
  })
  const {
    register,
    control,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    context: undefined,
    criteriaMode: 'firstError',
    shouldFocusError: true,
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    delayError: undefined,
    resolver: yupResolver(validationSchema),
    defaultValues: defValues
  })
//   const onclickreply = () => {
//    props.replyFunc()
//    props.message
    
//   }

  // API for comments
  useEffect(() => {
    if (patientopen > 0) {
      handleOpen1()
    }
  }, [patientopen])
  useEffect(() => {
    var message = props.message
    fields.forEach(field => {
      setValue(field, message[field])
    })
  }, [])






  const [claimIds, setClaimIds] = useState(null)
  //API for saving comments

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 100,
      filter: true,
      sortable: true,
      resizable: true
    }
  }, [])
  const style = {
    // position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '800px',
    marginTop: '10px',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    // boxShadow: 24,
    p: 4
  }


  function applyRefresh() {
    setRefresh(!refresh)
  }

  const [open1, setOpen1] = React.useState(false)
  const handleOpen1 = () => setOpen1(true)
  const handleClose1 = () => {
    setpatientopen(0)
    setOpen1(false)
  }
    const [openpatientreg, setOpenpatientreg] = React.useState(false);
  const handleOpenpatientreg = () => setOpenpatientreg(true);
  const handleClosepatientreg = () => setOpenpatientreg(false);
  const styleDetailspatient = {
    width: "90%",
    height: 600,
    bgcolor: "white",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    margin: "auto",
    marginTop: "10px",
    paddingBottom: "10px",
    padding: "20px",
    overflow: "auto",
    zIndex: 1500, // 🔥 This makes sure the modal stays on top
    scrollbarWidth: "thin",
    scrollbarColor: "#356F60 transparent",
    "&::-webkit-scrollbar": {
      width: 8,
      height: 8,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#356F60",
      borderRadius: 10,
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "transparent",
    },
    "&::-webkit-scrollbar-thumb:horizontal": {
      width: 4,
    },
  };
  return (
    <div>
      <Modal
        open={openpatientreg}
        onClose={handleClosepatientreg}
        sx={{ zIndex: 1500 }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={styleDetailspatient}>
          <Grid container columnSpacing={1}>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Typography style={{ fontWeight: "bold", color: "black" }}>
                Patient Registration
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ fontWeight: 500 }}>
              <Button
                onClick={handleClosepatientreg}
                style={{
                  marginTop: "0px",
                  marginBottom: "10px",
                  float: "right",
                  marginLeft: "10px",
                  width: "90px",
                  height: "35px",
                  // backgroundColor: '#A574FD',
                  color: "white",
                  fontSize: "14px",
                }}
              >
                <CancelOutlinedIcon
                  fontSize="medium"
                  style={{ color: "red", paddingRight: "5px" }}
                ></CancelOutlinedIcon>
              </Button>
            </Grid>
            <Grid item xs={12} style={{ fontWeight: 500, marginTop: "-90px" }}>
              <PatientRegistration
                callingFrom={"Authorization"}
                pid={PatientId}
                handleClosepatientreg={handleClosepatientreg}
              ></PatientRegistration>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Card>
        <CardContent>
         <Box display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              color="info"
              size="small"
              onClick={() => setOpenpatientreg(true)}
              sx={{
                textTransform: "none",
                borderRadius: "20px",
                px: 2,
                py: 0.8,
                fontWeight: 500,
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                },
              }}
            >
              Go to Patient Chart
            </Button>
          </Box>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={3.5}>
                <Typography style={{ fontWeight: "bold", color: "black" }}>
                  Patient Name:
                </Typography>
              </Grid>
              <Grid item xs={8.5}>
                <Typography style={{ color: "black" }}>
                  {props.message.patientName}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={{ fontWeight: "bold", color: "black" }}>
                  {" "}
                  Due Date:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography style={{ color: "black" }}>
                  {/* {props.message.dueDate} */}
                  {moment(props.message.dueDate).format("MM-DD-YYYY")}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={{ fontWeight: "bold", color: "black" }}>
                  AssignedTo:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography style={{ color: "black" }}>
                  {props.message.assignedTo}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography style={{ fontWeight: "bold", color: "black" }}>
                  Messages:
                </Typography>
              </Grid>
              <Grid item xs={9}>
                <Typography style={{ color: "black" }}>
                  {props.message.comments}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
}

export default DisplayComments
